<template>
    <properties-get
        :page="1"
        :per-page="1"
        :archived="false"
        v-slot="{
            meta,
            error: get_error,
            has_loaded,
            get
        }"
    >
        <template v-if="!has_loaded || get_error">
            <div>
                <base-loading
                    :error="get_error"
                    :retry="get"
                    class="py-6"
                />

                <error-modal
                    v-if="get_error"
                    :error="get_error"
                />
            </div>
        </template>

        <template v-else>
            <listings-store
                v-slot="{
                    sid,
                    is_loading: is_saving,
                    data: listing,
                    error,
                    store,
                    forget,
                }"
                @success="onListingsStoreSuccess"
                @error="onListingsStoreError"
            >
                <div>
                    <listing-form
                        :sid="sid"
                        :is-loading="is_saving"
                        :create-property="meta.total === 0"
                        class="mb-6"
                        @submit="store"
                    />

                    <error-modal
                        v-if="error && $error.is(error, { exclude: [422] })"
                        :error="error"
                    />

                    <modal-success
                        :is-open="show_created_modal"
                        @close="show_created_modal = false; forget()"
                    >
                        <template slot="heading">Listing Created!</template>

                        <p class="mb-3">
                            Your listing has been created!
                        </p>

                        <p class="mt-3 text-sm">
                            p.s. Don't forget to activate it once you've previewed it and are happy with it.
                        </p>

                        <template v-slot:footer="{ close }">
                            <div class="flex flex-col md:flex-row-reverse">
                                <router-link
                                        :to="{
                                        name: $router.fix('dashboard.landlords.listings.show'),
                                        params: {
                                            listing: listing.uuid
                                        }
                                    }"
                                        class="text-center btn btn-green"
                                >
                                    Go to Listing
                                </router-link>

                                <button
                                    type="button"
                                    @click.prevent="close"
                                    class="mt-3 text-center btn md:mt-0 md:mr-3"
                                >
                                    Add another
                                </button>
                            </div>
                        </template>
                    </modal-success>

                    <welcome-modal />
                </div>
            </listings-store>
        </template>
    </properties-get>
</template>

<script>
    import scroll from '../../../../support/scroll'
    import ListingForm from './_/listing-form'
    import ListingsStore from '../../../../components/listings-store'
    import WelcomeModal from './create/welcome-modal'
    import PropertiesGet from '../../../../components/properties-get'

    export default {
        components: {
            ListingForm,
            ListingsStore,
            WelcomeModal,
            PropertiesGet
        },
        data () {
            return {
                show_created_modal: false
            }
        },
        methods: {
            onListingsStoreSuccess () {
                this.$track(
                    'dashboard.landlords.listings.create',
                    'form-submission',
                    'A landlord has created a listing'
                )

                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            },
            onListingsStoreError () {
                scroll.toTop()
            }
        }
    }
</script>
